<template>
  <!-- 设置三级品类采购员坑位 -->
  <el-dialog
    title="设置坑位"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    class="dialog"
    center
  >
    <div style="max-height: 400px; overflow: auto" class="mt-20" v-loading="listLoading">
      <div
        v-for="(dItem, dIndex) in listData"
        :key="dIndex"
        class="d-flex a-center mb-15"
      >
        <div class="mr10" style="width: 200px; text-align: right">
          {{ dItem.fullname }}
        </div>
        <div>坑位</div>
        <div style="width: 200px; margin-left: 10px;">
          <el-input
            placeholder="请输入"
            v-model="dItem.slot"
            @blur="
              () =>
                (dItem.slot =
                  dItem.slot == 0 ? 0 : tool.filterUnNumber(dItem.slot, true))
            "
          >
          </el-input>
        </div>
      </div>
      <div v-if="!listLoading && listData.length === 0" class="text-center" style="color: #999; padding: 40px 0;">
        暂无数据
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onHandleSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import tool from "@/utils/tools/tool";
import { postBuyerCategoryList, postBuyerTagSave } from "@/api/generalControl/category";
export default {
  name: "set-three-pit",
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      listLoading: false,
      listData: [],
      cid: "",
      tag_id: "",
      logistic_business_id: "",
      tool,
    };
  },
  computed: {},
  methods: {
    async onInitData(row, cid, logistic_business_id) {
      this.tag_id = row.id;
      this.cid = cid;
      this.logistic_business_id = logistic_business_id;
      this.dialogVisible = true;
      this.submitLoading = false;
      this.listData = [];
      await this.getBuyerSlotList();
    },
    async getBuyerSlotList() {
      this.listLoading = true;
      try {
        const { data } = await postBuyerCategoryList({
          cid: this.cid,
          tag_id: this.tag_id,
          logistic_business_id: this.logistic_business_id,
        });
        this.listData = (data.list || []).map((item) => ({
          ...item,
          slot: item.slot != null ? item.slot : 0,
        }));
      } catch (error) {
        console.log(error, "postBuyerCategoryList");
      } finally {
        this.listLoading = false;
      }
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
    async onHandleSubmit() {
      this.submitLoading = true;
      let slot_list = this.listData.map((mItem) => ({
        buyer_id: mItem.id,
        slot: mItem.slot,
      }));
      try {
        const res = await postBuyerTagSave({
          tag_id: this.tag_id,
          cid: this.cid,
          slot_list,
        });
        this.$message({
          type: "success",
          message: res.msg || "保存成功",
        });
        this.submitLoading = false;
        this.dialogVisible = false;
        this.$emit("submit");
      } catch (error) {
        console.log(error, "postBuyerTagSave");
        this.submitLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
